import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function IncludedSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-white" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-85">
          <div className="text-center mb-12" data-id="element-86">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-87">
              💞 Por qué el Pack 100 Citas Familiares es único y especial
            </h2>
            <div className="w-24 h-2 bg-red-600 mx-auto rounded-full" data-id="element-88"></div>
          </div>

          <div className="space-y-12" data-id="element-89">
            {/* Qué vas a recibir */}
            <div data-id="element-90">
              <h3 className="text-2xl font-black text-red-600 mb-6 border-b-2 border-red-100 pb-2" data-id="element-91">
                ¿Qué vas a recibir?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-92">
                <div className="bg-red-50 p-4 rounded-xl flex gap-3 items-start border border-red-100" data-id="element-93">
                  <span className="text-2xl" data-id="element-94">📚</span>
                  <p className="text-gray-700 font-medium" data-id="element-95">
                    4 libros digitales completos, diseñados para fortalecer la
                    conexión entre padres e hijos.
                  </p>
                </div>
                <div className="bg-red-50 p-4 rounded-xl flex gap-3 items-start border border-red-100" data-id="element-96">
                  <span className="text-2xl" data-id="element-97">🎉</span>
                  <p className="text-gray-700 font-medium" data-id="element-98">
                    Más de 500 ideas para compartir momentos únicos, divertidos
                    y llenos de emoción.
                  </p>
                </div>
                <div className="bg-red-50 p-4 rounded-xl flex gap-3 items-start border border-red-100" data-id="element-99">
                  <span className="text-2xl" data-id="element-100">🗝️</span>
                  <p className="text-gray-700 font-medium" data-id="element-101">
                    Juegos secretos que revelan lo que sienten tus hijos y
                    mejoran la comunicación familiar.
                  </p>
                </div>
                <div className="bg-red-50 p-4 rounded-xl flex gap-3 items-start border border-red-100" data-id="element-102">
                  <span className="text-2xl" data-id="element-103">💌</span>
                  <p className="text-gray-700 font-medium" data-id="element-104">
                    Frases y actividades con propósito, para que tus hijos nunca
                    olviden cuánto los amás.
                  </p>
                </div>
                <div className="bg-red-50 p-4 rounded-xl flex gap-3 items-start border border-red-100 md:col-span-2" data-id="element-105">
                  <span className="text-2xl" data-id="element-106">🎁</span>
                  <p className="text-gray-700 font-medium" data-id="element-107">
                    Bonos exclusivos con retos semanales e ideas extras que
                    mantienen viva la magia del vínculo familiar.
                  </p>
                </div>
              </div>
            </div>

            {/* Qué vas a lograr con tu familia */}
            <div data-id="element-108">
              <h3 className="text-2xl font-black text-blue-600 mb-6 border-b-2 border-blue-100 pb-2" data-id="element-109">
                ¿Qué vas a lograr con tu familia?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-110">
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-111">
                  <span className="text-2xl" data-id="element-112">💬</span>
                  <p className="text-gray-700 font-medium" data-id="element-113">
                    Charlar más y conectar de verdad, alejándose de las
                    pantallas y volviendo a lo esencial.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-114">
                  <span className="text-2xl" data-id="element-115">😄</span>
                  <p className="text-gray-700 font-medium" data-id="element-116">
                    Crear recuerdos inolvidables sin gastar mucho dinero, con
                    actividades simples y efectivas.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-117">
                  <span className="text-2xl" data-id="element-118">💖</span>
                  <p className="text-gray-700 font-medium" data-id="element-119">
                    Fortalecer la confianza y la comunicación, compartiendo
                    momentos sinceros y espontáneos.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-120">
                  <span className="text-2xl" data-id="element-121">⏰</span>
                  <p className="text-gray-700 font-medium" data-id="element-122">
                    Aprovechar el tiempo juntos, sin necesidad de planificar ni
                    buscar ideas.
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100 md:col-span-2" data-id="element-123">
                  <span className="text-2xl" data-id="element-124">🌈</span>
                  <p className="text-gray-700 font-medium" data-id="element-125">
                    Recuperar la alegría en los pequeños momentos del día a día.
                  </p>
                </div>
              </div>
            </div>

            {/* Qué vas a lograr vos */}
            <div data-id="element-126">
              <h3 className="text-2xl font-black text-yellow-500 mb-6 border-b-2 border-yellow-100 pb-2" data-id="element-127">
                ¿Qué vas a lograr vos como mamá o papá?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-129">
                  <span className="text-2xl" data-id="element-130">✨</span>
                  <p className="text-gray-700 font-medium" data-id="element-131">
                    Dejar atrás la rutina y vivir experiencias reales que unan a
                    tu familia.
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-132">
                  <span className="text-2xl" data-id="element-133">🧠</span>
                  <p className="text-gray-700 font-medium" data-id="element-134">
                    Descubrir nuevas formas de conectar, entendiendo más a tus
                    hijos.
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-135">
                  <span className="text-2xl" data-id="element-136">💞</span>
                  <p className="text-gray-700 font-medium" data-id="element-137">
                    Sentirte presente y valorado, sabiendo que estás creando
                    recuerdos para toda la vida.
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-138">
                  <span className="text-2xl" data-id="element-139">🎯</span>
                  <p className="text-gray-700 font-medium" data-id="element-140">
                    Ahorrar tiempo y energía, con ideas listas para usar sin
                    planificar.
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100 md:col-span-2" data-id="element-141">
                  <span className="text-2xl" data-id="element-142">🌟</span>
                  <p className="text-gray-700 font-medium" data-id="element-143">
                    Convertirte en el corazón de tu familia, inspirando amor,
                    unión y diversión.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}